import Loader from './Loader';

export default function LoadingWrapper(props) {
    const { size = 40, color = '#335f9e' } = props;
    return (
        <div className="w-full h-full flex justify-center items-center min-h-[200px]">
            <Loader size={size} color={color} />
        </div>
    );
}
